<script>
import baseMixin from '@/mixins/baseMixin'
import { FormField } from '@/models/forms/fields/formField'
import { mapActions, mapGetters } from 'vuex'
import DownloadedFile from '@/models/file/downloadedFile'
import InfoLabel from '../general/info-label.vue'
import FileListWithPreviewGallery from '../files/file-list-with-preview-gallery.vue'

export default {
  name: 'FormSubmissionImageField',
  components: {
    InfoLabel,
    FileListWithPreviewGallery,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: FormField,
      required: true,
    },
    value: {
      required: true,
    },
  },
  data: () => {
    return {
      passkey: null,
      fileId: null,
      file: null,
      failedToLoad: false,
      errorObj: null,
      files: [],
    }
  },
  computed: {
    ...mapGetters({
      isLoadingFormFile: 'forms/isLoadingFormFile',
    }),
    isLoadingFile() {
      if (!this.fileId) return false
      return this.isLoadingFormFile(this.fileId)
    },
  },
  async created() {
    await this.downloadFormFile()
  },
  methods: {
    ...mapActions({
      downloadFile: 'forms/downloadFile',
    }),
    resetError() {
      this.failedToLoad = false
      this.errorObj = null
    },
    extractPasskeyAndFileIdFromURL() {
      const url = new URL(this.value)

      // File URL should be in format: /submissions/{passkey}/files/{fileId}
      const matchGuids = url.pathname.match(
        /[0-9A-Fa-f]{8}-?([0-9A-Fa-f]{4}-?){3}[0-9A-Fa-f]{12}/g
      )

      if (matchGuids.length !== 2) {
        this.passkey = null
        this.fileId = null
        throw new Error('Invalid file download URL. Could not download file')
      }

      return { passkey: matchGuids[0], fileId: matchGuids[1] }
    },
    async downloadFormFile() {
      this.resetError()
      const { passkey, fileId } = this.extractPasskeyAndFileIdFromURL()

      if ((!passkey, !fileId)) return

      const { isSuccess, data, errors } = await this.downloadFile({
        passkey,
        fileId,
      })

      if (!isSuccess) {
        this.failedToLoad = true
        this.errorObj = {
          code: errors?.data?.code || 'unknown_error',
          status: errors?.status,
        } || {
          code: 'unknown_error',
          status: null,
        }
        return
      }

      this.file = data

      this.files.push(
        new DownloadedFile({
          id: fileId, // serves as an identifier in the list
          accessGuid: passkey,
          type: this.file.blob.type,
          name: this.file.fileName,
          size: this.file.blob.size,
          file: this.file.blob, // to be downloaded when user clicks
        })
      )
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <div v-if="isLoadingFile"> loading </div>
      <div v-else-if="failedToLoad"> </div>
      <FileListWithPreviewGallery v-else :files="files" read-only hide-label />
    </InfoLabel>
  </div>
</template>
